import { SafetyCertificateOutlined, TeamOutlined } from '@ant-design/icons';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageHeader } from '@/components/PageHeader/PageHeader';
import { AdminUsersTab } from './components/AdminUsersTab';
import { RolesPermissionsTab } from './components/RolesPermissionsTab';
import styles from './Users.module.scss';

type UsersTab = 'users' | 'roles';

function resolveTab(value: string | null): UsersTab {
  if (value === 'roles') return 'roles';
  return 'users';
}

export default function Users() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = resolveTab(searchParams.get('tab'));

  const setTab = (tab: UsersTab) => {
    if (tab === 'users') {
      setSearchParams((params) => {
        const next = new URLSearchParams(params);
        next.delete('tab');
        return next;
      });
      return;
    }
    setSearchParams((params) => {
      const next = new URLSearchParams(params);
      next.set('tab', tab);
      return next;
    });
  };

  const tabContent = useMemo(() => {
    if (activeTab === 'roles') return <RolesPermissionsTab />;
    return <AdminUsersTab />;
  }, [activeTab]);

  return (
    <div className={styles.page}>
      <PageHeader />

      <div className={styles.layout}>
        <nav className={styles.topTabs} role="tablist" aria-label="User management">
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === 'users'}
            className={`${styles.topTab} ${activeTab === 'users' ? styles.topTabActive : ''}`}
            onClick={() => setTab('users')}
          >
            <TeamOutlined />
            Admin users
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === 'roles'}
            className={`${styles.topTab} ${activeTab === 'roles' ? styles.topTabActive : ''}`}
            onClick={() => setTab('roles')}
          >
            <SafetyCertificateOutlined />
            Roles &amp; permissions
          </button>
        </nav>

        <section className={styles.main} role="tabpanel">
          {tabContent}
        </section>
      </div>
    </div>
  );
}
